import { Box } from "@chakra-ui/react";
import type { StatusVariant } from "./StatusVariant";

const accentColor = (variant: StatusVariant): string => {
  if (variant === "ok") return "smSuccess";
  if (variant === "issue") return "smWarning";
  return "smStatusNeutralAccent";
};

// Full-height left status bar. The container must set `position="relative" overflow="hidden"`
// so the bar is clipped to the card's rounded corners.
export const StatusAccentBar = ({ variant }: { variant: StatusVariant }) => (
  <Box
    aria-hidden
    position="absolute"
    left="0"
    top="0"
    bottom="0"
    w="1"
    bg={accentColor(variant)}
  />
);
